import { CMS_ITEM_URL } from 'config/api-routes';
import { Middleware } from 'redux';
import { saveCmsData } from 'store/actions/cms.actions';
import { getLanguage } from 'utils/i18n';
import { GET } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

import { CMS_ACTIONS } from '../action-types/cms.action-types';

/**
 * CMS data service
 * @returns
 */
export const cmsServiceMiddleware: Middleware = () => {
  // place to init service that fetches data
  return (next) => async (action) => {
    switch (action.type) {
      // can be called independently
      case CMS_ACTIONS.FETCH_DATA_CALL: {
        try {
          const response = await GET(CMS_ITEM_URL(action.payload, { language: getLanguage() }));

          const data = formatResponse(response);

          if (!data) {
            break;
          }

          saveCmsData({ data, name: action.payload });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log('Failed to fetch cms data', error);
        }

        break;
      }
    }

    next(action);
  };
};
